import { Navigate } from 'react-router-dom'
import { getDataFromLocalStorage } from '@/utils/localStorage'
import cookieService from '@/utils/cookies'
import type { UserRole } from '@/services/auth'
import { ROUTES } from '@/constants'

interface PublicRouteProps {
  children: React.ReactNode
}

/**
 * PublicRoute — guards auth/public routes from already-authenticated users.
 * If the user has a valid access_token cookie, they get bounced to the
 * dashboard for their role instead of being shown the login screen again.
 */
export const PublicRoute = ({ children }: PublicRouteProps) => {
  const isLoggedIn = !!cookieService.getValue('access_token')
  const storedRole = getDataFromLocalStorage('role')
  const role = storedRole?.replace(/^"|"$/g, '') as UserRole | undefined
  // A token with no stored role is not a session this portal knows (for example a cookie set by
  // the other portal on the same host). The protected routes send such a visitor here, so
  // redirecting them back would loop; show the sign-in form and let the sign-in store the role.
  if (isLoggedIn && role) {
    const target = role === 'patient' ? ROUTES.PATIENT.DASHBOARD : ROUTES.APP.ROOT
    return <Navigate to={target} replace />
  }

  return <>{children}</>
}
